import * as types from "../mutation-type"
import axios from "axios/index";


export default {
  state: {
    testDocuments: {
      info:[]
    },
    testDocumentContent: {
      info:''
    },
  },
  mutations: {
    [types.SET_TEST_DOCUMENT](state, payload) {
      state.testDocuments.info = payload.info
    },
    [types.SET_TEST_DOCUMENT_CONTENT](state, payload) {
      state.testDocumentContent.info = payload.info
    },
  },
  actions: {
    getTestDocument({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "test-document/all"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_TEST_DOCUMENT,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },

    getTestDocumentContent({dispatch, commit},$payload) {

      let url = process.env.VUE_APP_API_URL + "test-document/"+$payload
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_TEST_DOCUMENT_CONTENT,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },
  }
}
